<template>
  <d2-container>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      v-permission:function="['jumpTypeManasger:btn_add']"
      @click="getAdd"
    >新增</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="jumpTypeList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="跳转地址">
        <template slot-scope="scope">
          <span>{{ scope.row.url }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.paramType == 0">无</span>
          <span v-if="scope.row.paramType == 1">分类</span>
          <span v-if="scope.row.paramType == 2">商品</span>
          <span v-if="scope.row.paramType == 3">优惠券</span>
          <span v-if="scope.row.paramType == 4">装修页</span>
          <span v-if="scope.row.paramType == 5">文章</span>
          <span v-if="scope.row.paramType == 6">手动输入</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="getEdit(scope.row)"
            v-permission:function="['jumpTypeManasger:btn_edit']"
            style="margin-top:10px"
          >修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="新增" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="140px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="paramType">
          <el-radio-group v-model="form.paramType">
            <el-radio :label="0">无</el-radio>
            <el-radio :label="1">分类</el-radio>
            <el-radio :label="2">商品</el-radio>
            <el-radio :label="3">优惠券</el-radio>
            <el-radio :label="4">装修页</el-radio>
            <el-radio :label="5">文章</el-radio>
            <el-radio :label="6">手动输入</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="地址" prop="url">
          <el-input v-model="form.url" placeholder="请输入地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button type="primary" @click="getAdopt('form')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增" :visible.sync="dialogFormUnEdit">
      <el-form :model="form" :rules="rules" ref="form" label-width="140px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="paramType">
          <el-radio-group v-model="form.paramType">
            <el-radio :label="0">无</el-radio>
            <el-radio :label="1">分类</el-radio>
            <el-radio :label="2">商品</el-radio>
            <el-radio :label="3">优惠券</el-radio>
            <el-radio :label="4">装修页</el-radio>
            <el-radio :label="5">文章</el-radio>
            <el-radio :label="7">地图页</el-radio>
            <el-radio :label="8">自动回复</el-radio>
            <el-radio :label="6">手动输入</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="地址" prop="url">
          <el-input v-model="form.url" placeholder="请输入地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="canscel('form')">取 消</el-button>
        <el-button type="primary" @click="getAdopst('form')">确 定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { getTypePage, getTypeAdd, getTypeUpdate } from '@/api/demo/news/index'
export default {
  name: 'jumpTypeManasger',
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      jumpTypeManasger_btn_add: false,
      jumpTypeManasger_btn_edit: false,
      tableKey: 0,
      jumpTypeList: [],
      dialogFormVisible: false,
      dialogFormUnEdit: false,
      form: {
        name: '', // 名称
        paramType: 0, // 类型
        url: '' // 跳转地址
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 100,
            message: '长度在 1 到 100 个字符',
            trigger: 'blur'
          }
        ],
        url: [
          {
            required: true,
            message: '请输入地址',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getList()
  },
  mounted () {},
  methods: {
    getList () {
      let that = this
      getTypePage().then(res => {
        that.jumpTypeList = res
      })
    },
    // 新增
    getAdd (form) {
      let that = this
      that.dialogFormVisible = true
    },
    // 取消
    cancel (form) {
      let that = this
      that.$refs[form].resetFields()
      that.dialogFormVisible = false
    },
    getAdopt (form) {
      let that = this
      const set = this.$refs
      set[form].validate(valid => {
        if (valid) {
          getTypeAdd(that.form).then(res => {
            that.getList()
            that.dialogFormVisible = false
          })
        }
      })
    },
    // 修改
    getEdit (row) {
      console.log('row', row)
      let that = this
      that.form = row
      that.form.paramType = JSON.parse(row.paramType)
      that.dialogFormUnEdit = true
    },
    canscel (form) {
      let that = this
      that.$refs[form].resetFields()
      that.dialogFormUnEdit = false
    },
    getAdopst (form) {
      let that = this
      const set = this.$refs
      set[form].validate(valid => {
        if (valid) {
          getTypeUpdate(that.form.id, that.form).then(res => {
            that.getList()
            that.dialogFormUnEdit = false
          })
        }
      })
    }
  }
}
</script>
<style>
</style>
